import React from "react";
import RootLayout from "../../../core/ui/layouts/RootLayout";
import { Col, Layout, Menu, Row, Space } from "antd";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { TPresentable } from "../../../core/presenter/withStore";
import Link from "../../../core/ui/components/Link";
import logo from "../../../core/ui/assets/images/logo-new.png";
import { ILanguage } from "../../../core/model/language/Language";
import ChangeLanguageInteractor from "../../../core/interactor/language/ChangeLanguageInteractor";
import Application from "../../../Application";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import { TPortalHomePresenter } from "../../presenter/PortalHomePresenter";
import LanguageSelectionList from "../../../core/ui/components/LanguageSelectionList";
import { MenuOutlined, YoutubeOutlined } from "@ant-design/icons";
import LayoutFooter from "./LayoutFooter";

const { Header, Content } = Layout;

export interface Props {
  router: any;
  children?: any;
  translate: TTranslate;
  style?: any;
  params?: any;
}
export interface State extends TPresentable {
  collapsed: boolean;
}

export default class PortalLayout extends React.Component<Props, State> {
  private subscriptionId: number = 0;
  constructor(props) {
    super(props);
    this.state = { ...props, collapsed: true };
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { children, translate, router } = this.props;
    const {
      languages,
      application,
      selectedLanguage
    }: {
      languages: ILanguage[];
      application: Application;
      selectedLanguage: ILanguage;
    } = this.state as any;
    const organisation =
      this.state.store.getState<TPortalHomePresenter>()?.organisation;

    const changeLanguage = async (language: ILanguage) => {
      try {
        await application.container
          .resolve<ChangeLanguageInteractor>("changeLanguage")
          .execute(language.code, true);
        application.changeSystemLanguage(language.code);
        application.navigator.reload();
      } catch (error: any) {}
    };

    return (
      <RootLayout {...this.props}>
        <Layout className={"layout-main-wrapper"}>
          <Layout className={"layout-content-wrapper"}>
            <Header className="portal-layout-header">
              <Row className="w-100 h-100">
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={16}
                  xl={18}
                  xxl={19}
                  className=" vertical-align-middle"
                >
                  <div className="display-flex flex-direction-row vertical-align-middle">
                    <Link router={router} path="/">
                      <img
                        src={logo}
                        alt="Logo"
                        style={{
                          height: "65px"
                        }}
                      />
                    </Link>
                    <Link
                      router={router}
                      path="/"
                      className="display-flex flex-direction-column left-12"
                    >
                      <Title
                        level={1}
                        className="portal-layout-header-app-title text-align-left"
                      >
                        {organisation
                          ? organisation.name
                          : translate("app.portal")}
                      </Title>
                      <Text
                        style={{
                          color: "white",
                          fontWeight: 400,
                          fontSize: 20,
                          lineHeight: 1,
                          textAlign: "center"
                        }}
                      >
                        {organisation ? translate("app.portal") : ""}
                      </Text>
                    </Link>
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={8}
                  xl={6}
                  xxl={5}
                  className="display-flex align-center align-md-right vertical-align-top mt-2 mt-md-0"
                >
                  <LanguageSelectionList
                    onChangeLanguage={changeLanguage}
                    languages={languages}
                    selectedLanguage={selectedLanguage}
                  />
                </Col>
              </Row>
            </Header>
            <Header className="portal-layout-subheader">
              <Menu
                mode="horizontal"
                className={"header-menu-primary"}
                overflowedIndicator={
                  <MenuOutlined style={{ alignSelf: "center" }} />
                }
              >
                <Menu.Item key="menu:case_law_document">
                  <Link router={router} path="/search?collection=STAV&q=">
                    {translate("editors.case_law_documents.case_law_document")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="menu:case_decision">
                  <Link router={router} path="/search?collection=ODLUKA&q=">
                    {translate("editors.case_decisions.title")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="menu:legal_view">
                  <Link
                    router={router}
                    path="/search?collection=PRAVNO_SHVATANJE&q="
                  >
                    {translate("editors.legal_views.title")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  style={{
                    color: "white",

                    marginLeft: "auto",
                    display: "flex",
                    alignItems: "center"
                  }}
                  key="menu:user_manual"
                >
                  <Link
                    target="_tab"
                    className="white-text"
                    router={router}
                    href={translate("app.user_manual")}
                  >
                    {translate("app.user_manual_tooltip")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  style={{
                    color: "white",

                    display: "flex",
                    alignItems: "center"
                  }}
                  key="menu:manual"
                  icon={
                    <YoutubeOutlined
                      style={{
                        color: "#FF0000",

                        fontSize: 30
                      }}
                    />
                  }
                >
                  <Link
                    className="white-text"
                    router={router}
                    target="_tab"
                    href={translate("app.video_tutorial")}
                  >
                    {translate("app.video_tutorial_tooltip")}
                  </Link>
                </Menu.Item>
              </Menu>
            </Header>
            <Content
              className={"layout-content-container"}
              style={Object.assign({}, {}, this.props.style || {})}
            >
              <div className={"layout-content-container-children"}>
                {children}
              </div>
              <LayoutFooter translate={translate} />
            </Content>
          </Layout>
        </Layout>
      </RootLayout>
    );
  }
}
